import { privateRoutes } from "./privateRoutes";
import { publicRoutes } from "./publicRoutes";

const ROLES_ROUTES:any = {
    0: publicRoutes,
    1: privateRoutes,
    
  };
  
  export const getRoutes = (role:number) => {
    return ROLES_ROUTES[role];
  };